var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCo = function SvgCo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h42.667v32H0V0z",
    fill: "#FFE800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16h42.667v16H0V16z",
    fill: "#00148E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24h42.667v8H0v-8z",
    fill: "#DA0010"
  })));
};
export default SvgCo;